<template>
  <div class="case">
    <van-nav-bar fixed placeholder title="我发布的案例" left-arrow @click-left="$router.go(-1)">
      <template #right>
        <div class="shaixuanitem" @click="filter.show=true">
          <van-icon class="iconfont m-r-5" size="20" color="#4f75cc" class-prefix="icon" name="shaixuanx" />
        </div>
      </template>
    </van-nav-bar>
    <!-- <div class="casetitle flex">
      <h3>我发布的案例</h3>
      <div class="shaixuanitem" @click="filter.show=true">日期筛选
        <van-icon class="iconfont m-r-5" size="20" color="#4f75cc" class-prefix="icon" name="shaixuanx" />
      </div>
    </div> -->

    <div class="newslist m-b-100">
      <van-list v-model="news.loading" :finished="news.finished" finished-text="" @load="loadCaseList">
        <van-cell title-style="text-align:left;" v-for="(item,index) in news.list" :key="index" :title="item.title" :label="global.formatDate(item.createTime,'yyyy-MM-dd')">
          <template #right-icon>
            <van-icon size=16 color="#f6c6c6" class="m-t-5 m-r-5" name='smile' /> {{item.zanTotalCount}}
            <van-icon size=16 color="#079e60" class="m-l-10 m-t-5 m-r-5" name='eye' /> {{item.viewNum}}
          </template>
        </van-cell>
      </van-list>
    </div>
    <van-tabbar style="height:105px; display:inline;" safe-area-inset-bottom>
      <div class="caselisttips m-t-5">友情提示：阅览量只显示上月数据</div>
      <div class="m-l-10 m-r-10 publishcasebutton">
        <van-button type="primary" @click="publishEvent" block>立即发布案例</van-button>
      </div>
    </van-tabbar>

    <van-action-sheet title="请选择时间段" v-model="filter.show" cancel-text="搜索" close-on-click-action @cancel="onCancel">
      <div class="content">
        <van-cell-group>
          <van-field v-model="filter.startDate" label="开始日期：" @click="chooseDate('startDate')" placeholder="请选择" />
        </van-cell-group>
        <van-cell-group>
          <van-field v-model="filter.endDate" label="结束日期：" @click="chooseDate('endDate')" placeholder="请选择" />
        </van-cell-group>
      </div>
    </van-action-sheet>

    <van-popup v-model="filter.picker.show" position="bottom">
      <van-datetime-picker v-model="filter.picker.currentDate" @confirm="filterFinish()" @cancel="filter.picker.show=false" type="date" title="选择年月日" :min-date="filter.picker.minDate" :max-date="filter.picker.maxDate" />
    </van-popup>

    <van-popup class="pubilshCaselayer" v-model="publishCase.show" position="right" :style="{ height: '100%',width:'100%' }">
      <van-nav-bar fixed placeholder title="发布案例" left-arrow @click-left="publishCaseClose">
      </van-nav-bar>
      <div v-if="!publishCase.resultShow" class="publishCase">
        <van-cell-group>
          <van-field v-model="publishCase.casetitle" label="标题：" placeholder="请输入标题" />
        </van-cell-group>

        <div class="ta-l m-l-5 m-b-5 f-12 m-t-20">请添加音频</div>
        <div class="upload ta-l">
          <!-- <div> flex
            <van-image width="80" src="/images/cd.jpg" />
          </div> -->
          <!-- <div>
            <div class="lable">请选择音频</div>

          </div> -->
          <!-- <div class="uploadbutton">
            </div> -->
          <van-uploader @oversize="oversize" result-type="file" :max-count="2" multiple upload-icon="/images/music.png" accept=".wav,.mp3,.m4a,.ogg,.acc,.webm,audio/*" :max-size="30*1000*1024" v-model="publishCase.fileList" :after-read="afterRead">
            <!-- <van-button icon="plus" type="primary" color="#2d79ba" size="small">添加音频</van-button> -->
          </van-uploader>
        </div>

        <div class="ta-l m-l-5 m-b-5 f-12 m-t-20">请选择发布位置（必选）</div>
        <CarChooseDownList v-for="item in publishCase.items" :key="item.id" :item="item" @call-func="getBrandNode($event)"></CarChooseDownList>
        <div class="f-12 m-t-10" style="color:red">*其他年份，其他排量，请传至“案例大全”选项 </div>
        <div class="m-l-10 m-r-10 publishcasebutton">
          <van-button type="primary" color="#45a4b6" @click="publish" block>发布案例</van-button>
        </div>
      </div>
      <div v-if="publishCase.resultShow" class="publishCaseResult">
        <van-icon class="m-t-20" size=100 color="#48c59b" name="checked" />
        <h3>恭喜您，案例发布成功！</h3>
        <p>请耐心等待管理员审核...</p>
        <div class="line-1"></div>
        <p>审核通过后可在</p>
        <h4>“我发布的案例”里查看。</h4>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Cell,
  CellGroup,
  Image as VanImage,
  Tag,
  Popup,
  NavBar,
  Form,
  Button,
  Field,
  CountDown,
  Toast,
  List,
  Notify,
  DatetimePicker,
  ActionSheet,
  Uploader,
  Tabbar,
  TabbarItem,
} from "vant";
import {
  Get_Case_List,
  Get_Brand_Node,
  Upload_File,
  Add_Case,
} from "@/api/index";
import CarChooseDownList from "@/components/CarChooseDownList.vue";
export default {
  name: "UserCase",
  components: {
    CarChooseDownList,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [VanImage.name]: VanImage,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Button.name]: Button,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [List.name]: List,
    [Notify.name]: Notify,
    [DatetimePicker.name]: DatetimePicker,
    [ActionSheet.name]: ActionSheet,
    [Uploader.name]: Uploader,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  data() {
    return {
      user: this.global.getUserInfo(),
      news: {
        list: [],
        loading: false,
        finished: false,
        page: 1,
      },
      filter: {
        show: false,
        startDate: "",
        endDate: "",
        currentInputName: "",
        picker: {
          show: false,
          minDate: new Date(2020, 9, 23),
          maxDate: new Date(),
          currentDate: new Date(),
        },
      },
      publishCase: {
        selectText: "",
        items: [],
      },
    };
  },
  methods: {
    publishCaseClose() {
      this.publishCase.show = false;
      this.news.list = [];
      this.loadCaseList();
    },
    publishEvent() {
      this.publishCase = {
        show: false,
        resultShow: false,
        casetitle: "",
        fileList: [],
        items: [],
        selectValue: 0,
        uploadList: [],
      };
      this.publishCase.show = true;
      this.getBrandNode([1, 1, {}]);
    },
    oversize() {
      Toast("文件大小不能超过30M");
    },
    chooseDate(name) {
      this.filter.picker.show = true;
      this.filter.currentInputName = name;
    },
    filterFinish(value) {
      if (this.filter.currentInputName == "startDate") {
        this.filter.startDate = this.global.formatDate(
          this.filter.picker.currentDate,
          "yyyy-MM-dd"
        );
        if (this.filter.picker.currentDate > this.filter.picker.minDate) {
          this.filter.picker.minDate = this.filter.picker.currentDate;
        }
      } else {
        this.filter.endDate = this.global.formatDate(
          this.filter.picker.currentDate,
          "yyyy-MM-dd"
        );
      }
      this.filter.picker.show = false;
    },
    loadCaseList() {
      this.news.loading = true;
      Get_Case_List({
        memberId: 0,
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        type: 1,
          pageSize: 20,
        pageIndex: this.news.page,
      }).then((data) => {
        this.news.finished = data.pageCount <= this.news.page;
        this.news.list = this.news.list.concat(data.dataList);
        this.news.page++;
        this.news.loading = false;
      });
    },
    onCancel() {
      this.filter.show = false;
      this.news.page = 1;
      this.news.list = [];
      this.loadCaseList();
    },
    afterRead(file) {
      // file.status = "uploading";
      // file.message = "上传中...";

      // setTimeout(() => {
      //   file.status = "failed";
      //   file.message = "上传失败";
      // }, 1000);
      var formData = new FormData();
      // if (this.publishCase.fileList.length > 0) {
      //   this.publishCase.fileList.forEach((e) =>
      //     formData.append("files", e.file)
      //   );
      // }
      if (!Array.isArray(file)) {
        formData.append("files", file.file);
      } else {
        file.forEach((e) => formData.append("files", e.file));
      }

      Upload_File(formData).then((m) => {
        m.forEach((e) => {
          this.publishCase.uploadList.push(e);
        });
      });
    },
    async publish() {
      if (this.publishCase.casetitle == "") {
        Toast("请输入标题");
        return;
      }
      if (this.publishCase.uploadList.length == 0) {
        Toast("请添加音频");
        return;
      }
      if (this.publishCase.selectValue < 10) {
        Toast("请选择发布位置");
        return;
      }

      let filePath = [];
      this.publishCase.uploadList.forEach((e) => {
        filePath.push(e.filePath);
      });

      let caseModel = {
        BrandId: this.publishCase.selectValue,
        MemberId: this.user.memberId,
        Title: this.publishCase.casetitle,
        FilePath: filePath.join(","),
        BrandPath: this.publishCase.selectText,
      };
      let that = this;
      await Add_Case(caseModel).then((e) => {
        that.publishCase.resultShow = true;
      });
    },
    async getBrandNode(obj) {
      if (this.publishCase.items.some((item) => item.id == obj[0])) return;

      var currentItem = this.publishCase.items.find(
        (item) => item.id == obj[1]
      );
      if (currentItem) {
        if (this.publishCase.selectText)
          this.publishCase.selectText += currentItem.name + " > ";
        else this.publishCase.selectText = currentItem.name + " > ";
      }

      this.$set(obj[2], "showId", obj[0]);
      if (obj[2].level && obj[2].level > 4) {
        this.publishCase.selectValue = obj[0];
        this.publishCase.selectText += currentItem.subList.find(
          (item) => item.id == obj[0]
        ).name;
        return;
      }

      var index = this.publishCase.items.findIndex((item) => item.id == obj[1]);
      if (index >= 0) this.publishCase.items.splice(index + 1);

      var params = {
        id: obj[0],
        depth: 2,
      };
      this.publishCase.items.push(await Get_Brand_Node(params));
    },
  },
  mounted: function () {
    this.getBrandNode([1, 1, {}]);
  },
};
</script>
